import { render, staticRenderFns } from "./RevisionOrganosSistemas.vue?vue&type=template&id=38501d72"
import script from "./RevisionOrganosSistemas.vue?vue&type=script&lang=js"
export * from "./RevisionOrganosSistemas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports